import DeleteController from "csi/table/Delete";
import MessageDialog from "csi/widget/MessageDialog";
import locale from "csi/locale";
import declare from "dojo/_base/declare";

const WbsTemplatesDeleteController = declare(DeleteController, {
	/**
	 * @override
	 * Displays an error message if the error is caused by the SRV_ERR_SiteAdmin_DELETE_ON_USED errorCode.
	 * Indicates that the Template is currently assigned as a Milestone Template.
	 */
	displayError() {
		if (this._errorCode === "SRV_ERR_SiteAdmin_DELETE_ON_USED") {
			const message = locale.resource("DeleteWBS");
			const buttons = [MessageDialog.BUTTON_CANCEL];
			this.confirmAction({ message, buttons });
		} else {
			this.inherited(arguments);
		}
	},
});

export = WbsTemplatesDeleteController;